// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "clipboard" + "." + "d8a6405bd756ab66c603" + ".js";
};